import { useEffect, useCallback, useRef } from 'react'
import { autorun } from 'mobx'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import withResolution from 'hoc/withResolution'
import User from 'singletons/User'
import MobileMenu from './MobileMenu'
import Drawer from './Drawer'
import Main from './Main'
import { DASHBOARD } from 'constants/breakpoints'
import { LOGIN } from 'constants/routing'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import useFlaggingAttributes from 'components/FeatureFlag/useFlaggingAttributes'
import usePushService from 'hooks/usePushService'
import useStyles from './styles'
import SideNavSingleton from 'singletons/SideNav'

const Dashboard = ({ isMobile }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  usePushService()

  // TODO: Mobxify feature flagging instead of using react hooks.
  const { attributes, isAttributesReady } = useFlaggingAttributes()
  const ldClient = useLDClient()
  const lastIdentify = useRef('')

  const identifyUser = useCallback(() => {
    const stringified = JSON.stringify(attributes)
    if (lastIdentify.current === stringified) {
      lastIdentify.current = stringified
      return
    }
    lastIdentify.current = stringified
    ldClient?.identify(attributes)
  }, [ldClient, attributes, lastIdentify?.current])

  useEffect(
    () =>
      autorun(() => {
        if (User.needsLogin) {
          navigate(LOGIN)
        } else {
          if (isAttributesReady) {
            identifyUser()
          }
        }
      }),
    [],
  )

  return User.provider ? (
    <div className={classNames(classes.root, isMobile && classes.mobileRoot)}>
      {isMobile || !SideNavSingleton.isOpen ? null : <Drawer />}
      <Main />
      {isMobile ? <MobileMenu /> : null}
    </div>
  ) : null
}

Dashboard.propTypes = {
  isMobile: PropTypes.bool.isRequired,
}

export default withResolution(DASHBOARD)(observer(Dashboard))
